import type {
  Cinema,
  HallCatalog,
  MovieHall,
  Schedule,
  Seatmap,
  SearchResponse,
} from "./types";

async function get<T>(url: string, init?: RequestInit): Promise<T> {
  const response = await fetch(url, init);
  if (!response.ok) {
    const body = await response.json().catch(() => ({ error: response.statusText }));
    throw new Error(body.error ?? `Erreur ${response.status}`);
  }
  return response.json() as Promise<T>;
}

export const fetchCinemas = () => get<Cinema[]>("/api/cinemas");

export const fetchSchedule = (cinemaSlug: string, date?: string) =>
  get<Schedule>(
    `/api/cinemas/${cinemaSlug}/schedule${date ? `?date=${encodeURIComponent(date)}` : ""}`,
  );

export const fetchSeatmap = (cinemaId: string, showingId: string) =>
  get<Seatmap>(`/api/showings/${cinemaId}/${showingId}/seatmap`);

export const fetchHalls = (cinemaSlug: string, date: string) =>
  get<HallCatalog>(`/api/cinemas/${cinemaSlug}/halls?date=${encodeURIComponent(date)}`);

export const refreshHalls = (cinemaSlug: string, date: string) =>
  get<HallCatalog>(`/api/cinemas/${cinemaSlug}/halls/refresh?date=${encodeURIComponent(date)}`, {
    method: "POST",
  });

export const fetchMovieHalls = (cinemaSlug: string, movieSlug: string, date: string) =>
  get<{ showtimes: MovieHall[] }>(
    `/api/cinemas/${cinemaSlug}/movies/${movieSlug}/halls?date=${encodeURIComponent(date)}`,
  );

export const searchShowtimes = (cinemaSlug: string, payload: Record<string, unknown>) =>
  get<SearchResponse>(`/api/cinemas/${cinemaSlug}/search`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
